import $ from 'jquery';
import { createMap, onChooseSitesMapCreated } from 'map';
import { onAddRoute, onModifySection } from 'map-callbacks';

$(() => {
    const modes = ['selectRoute', 'modifySection', 'selectSections', 'streetView'];
    const handlers = {
        addRouteCallback: onAddRoute,
        modifySectionCallback: onModifySection
    };
    createMap('mapElement', null, modes, handlers, []).then(onChooseSitesMapCreated);
});
